// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".556.0.0." + {"1367": "9bf449e5661b6576","2257": "9c56e4db323e0b3e","2973": "2ac2e887c6b94230","582": "4132300267932823","7530": "257ea47e6e931e8f","7581": "ddb63471f1650f79","8692": "4f3048c06bd53515",}[chunkId] + ".css"
}